// extracted by mini-css-extract-plugin
export default {"container":"application-container_container__G7oid","content":"application-container_content__yZr7T"};